// src/context/AuthContext.jsx
import React, { createContext, useEffect, useState } from "react";
import api from "../api/api";

export const AuthContext = createContext({
  token: null,
  user: null,
  setAuth: () => {},
  clearAuth: () => {},
  setUser: () => {},
});

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);

  // Initialize token from localStorage once
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      api.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
      setToken(storedToken);
    } else {
      delete api.defaults.headers.common["Authorization"];
      setToken(null);
    }
  }, []);

  const setAuth = (newToken, newUser = null) => {
    if (newToken) {
      localStorage.setItem("token", newToken);
      api.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
      setToken(newToken);
      if (newUser) setUser(newUser);
    } else {
      localStorage.removeItem("token");
      delete api.defaults.headers.common["Authorization"];
      setToken(null);
      setUser(null);
    }
  };

  const clearAuth = () => setAuth(null);

  return (
    <AuthContext.Provider
      value={{
        token,
        user,
        setAuth,
        clearAuth,
        setUser, // keep for backward compatibility (management pages etc.)
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
